import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import { motion } from 'framer-motion';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import TabbedFormComponent from '../../common/TabbedFormComponent';
import AdvancedDataTableComponent from '../../common/AdvancedDataTableComponent';
import { fetchClientData } from '../../../services/adminApiService';
import { registerVerificationType, updateVerificationType, fetchVerficationTypeData, fetchVerificationTypeDataById } from '../../../services/client/verificationTypeApiService'; // Adjust the path as necessary
import FloatingLabelInput from '../../ui/FloatingLabelInput';
import FloatingLabelSelect from '../../ui/FloatingLabelSelect';

const VerificationTypeForm = ({ selectedVerificationType, onVerificationTypeUpdated }) => {
  const [isEditing, setIsEditing] = useState(false);
    const [apiResponse, setApiResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState({
    clientId: '',
    verificationTypeId: '',
    verificationType: '',
    formFields: [
      {
        name: '',
        type: 'text',
        required: false,
        options: []
      }
    ]
  });

  const [clients, setClients] = useState([]);

  useEffect(() => {
    // Fetch clients from API
    const fetchClients = async () => {
      try {
        const clientData = await fetchClientData();
        setClients(clientData.map(client => ({ value: client.clientId, label: client.clientName })));
    } catch (error) {
        console.error("Error fetching countries:", error);
    }
    };

    fetchClients();
  }, []);

  
  useEffect(() => {
    const timer = setTimeout(() => {
        if (selectedVerificationType && selectedVerificationType.serviceTypeId != "") {
            setIsEditing(true);
            setFormValues({
              clientId: selectedVerificationType.clientId || '',
              verificationTypeId: selectedVerificationType.verificationTypeId || '',
              verificationType: selectedVerificationType.verificationType || '',
              formFields: Array.isArray(selectedVerificationType.formFields)
                    ? selectedVerificationType.formFields.map(obj => obj)
                    : []
            });
        } else {
            setIsEditing(false);
        }
    }, 500); // 3000ms = 3 seconds

    return () => clearTimeout(timer);
}, [selectedVerificationType, clients]); // Ensure to re-run when countries change


  const inputClasses = (field) =>
    errors[field] ? 'border-red-500' : 'border-gray-300';

  // Simple validation function
  const validate = () => {
    const newErrors = {};
    if (!formValues.verificationType) newErrors.verificationType = 'Component is required';
    if (!formValues.clientId) newErrors.clientId = 'Organization is required';

    formValues.formFields.forEach((field, index) => {
      if (!field.name) {
        newErrors[`field_${index}_name`] = 'Field name is required';
      }
  
      if ((field.type === 'checkbox' || field.type === 'radio') && field.options.length === 0) {
        newErrors[`field_${index}_options`] = 'At least one option is required for checkbox/radio';
      }
    });


    return newErrors;
};

const handleBlur = (field) => {
    const validationErrors = validate();
    setErrors(validationErrors);
};

  const handleFieldChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const updatedFields = [...formValues.formFields];
    updatedFields[index][name] = type === 'checkbox' ? checked : value;
    setFormValues({ ...formValues, formFields: updatedFields });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const addField = () => {
    setFormValues({
      ...formValues,
      formFields: [
        ...formValues.formFields,
        { name: '', type: 'text', required: false, options: [] }
      ]
    });
  };

  const removeField = (index) => {
    const updatedFields = [...formValues.formFields];
    updatedFields.splice(index, 1);
    setFormValues({ ...formValues, formFields: updatedFields });
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      //console.log(formValues);
        try {
            //console.log('Form submitted', formValues);
            setLoading(true);
            let data;
            if (isEditing) {
                data = await updateVerificationType(formValues);
            } else {
                data = await registerVerificationType(formValues);
            }

            setApiResponse(data);
            if (!data.error) {
                resetFormValues();
                onVerificationTypeUpdated(null);
                setIsEditing(false);
                //setClients([]);
            } else {
                return;
            }
        } catch (err) {
            const validationErrors = {};
            err.inner.forEach(error => {
                validationErrors[error.path] = error.message;
            });
            setErrors(validationErrors);
            setApiResponse({ err: 'Failed to submit form. Please try again.' });
        } finally {
            setLoading(false);
        }
        setErrors({});
    } else {
      alert("not Validate");
        setErrors(validationErrors);
    }
};

const resetFormValues=()=>{
  setFormValues({
    clientId: '',
    verificationTypeId: '',
    verificationType: '',
    formFields: [
      {
        name: '',
        type: 'text',
        required: false,
        options: []
      }
    ]
  });
}

  return (
    <div className="container mx-auto p-6 bg-white rounded-lg border">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {isEditing ?
                        <input
                            type="hidden"
                            name="verificationTypeId"
                            value={formValues.verificationTypeId}
                            id="verificationTypeId"
                            autoComplete="off"
                            readOnly={true}
                            onChange={handleChange}
                        /> : ''
                    }

<div>
                        {loading ? (
                            <p>Loading countries...</p>
                        ) : (
                            <FloatingLabelSelect
                                label="Select Organization"
                                id="clientId"
                                name="clientId"
                                value={clients.find(client => client.value === formValues.clientId) || null} // Handle no selection case with null
                                onChange={(option) => setFormValues({ ...formValues, clientId: option.value })}
                                onBlur={() => handleBlur('clientId')}
                                className={inputClasses('clientId')}
                                options={clients}
                                isSearchable={true}
                            />
                        )}
                        {errors.clientId && <div className="text-red-500 text-sm">{errors.clientId}</div>}
                    </div>

                    <div>
                        <FloatingLabelInput
                            label="Component"
                            id="verificationType"
                            name="verificationType"
                            value={formValues.verificationType}
                            onChange={handleChange}
                            onBlur={() => handleBlur('verificationType')}
                            className={inputClasses('verificationType')}

                        />
                         {errors.verificationType && <div className="text-red-500 text-sm">{errors.verificationType}</div>}
                    </div>

                    
                </div>
      {/* <div className="mb-6">
        <label className="block text-gray-700 font-medium mb-1">Select Client</label>
        <select
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          name="clientId"
          value={formValues.clientId}
          onChange={handleChange}
        >
          <option value="">Select a client</option>
          {clients.map(client => (
            <option key={client.id} value={client.id}>
              {client.name}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-6">
        <label className="block text-gray-700 font-medium mb-1">Form Name</label>
        <input
          type="text"
          name="formName"
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Form Name"
          value={formValues.formName}
          onChange={handleChange}
        />
      </div> */}

      <h3 className="text-xl font-semibold mb-4 text-gray-700">Fields</h3>
      
      {/* Table header */}
      <div className="grid grid-cols-5 gap-4 items-center font-medium text-gray-700 mb-2">
        <div>Field Name</div>
        <div>Field Type</div>
        <div>Required</div>
        <div>Options (for checkbox/radio)</div>
        <div>Actions</div>
      </div>
{(formValues.formFields)? (
  <>
      {formValues.formFields.map((field, index) => (
  <div
    key={index}
    className="grid grid-cols-5 gap-4 items-center mb-4 border-b pb-4"
  >
    <input
      type="text"
      name="name"
      className={`px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors[`field_${index}_name`] ? 'border-red-500' : 'border-gray-300'}`}
      placeholder="Field Name"
      value={field.name}
      onChange={(e) => handleFieldChange(index, e)}
      onBlur={() => handleBlur(`field_${index}_name`)}
    />
    {errors[`field_${index}_name`] && <div className="text-red-500 text-sm">{errors[`field_${index}_name`]}</div>}

    <select
      name="type"
      className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
      value={field.type}
      onChange={(e) => handleFieldChange(index, e)}
    >
      <option value="text">Text</option>
      <option value="number">Number</option>
      <option value="checkbox">Checkbox</option>
      <option value="radio">Radio Button</option>
    </select>

    <div className="flex items-center">
      <input
        type="checkbox"
        name="required"
        checked={field.required}
        onChange={(e) => handleFieldChange(index, e)}
        className="h-5 w-5 text-blue-500 focus:ring-blue-500"
      />
    </div>

    {(field.type === 'checkbox' || field.type === 'radio') ? (
      <div>
        {field.options.map((option, optIndex) => (
          <div key={optIndex} className="flex items-center mb-1">
            <input
              type="text"
              value={option}
              placeholder="Option"
              onChange={(e) => {
                const updatedFields = [...formValues.formFields];
                updatedFields[index].options[optIndex] = e.target.value;
                setFormValues({ ...formValues, formFields: updatedFields });
              }}
              className="px-2 py-1 border rounded-lg w-full"
            />
            <button
              onClick={() => {
                const updatedFields = [...formValues.formFields];
                updatedFields[index].options.splice(optIndex, 1);
                setFormValues({ ...formValues, formFields: updatedFields });
              }}
              className="ml-2 text-red-500 hover:text-red-700"
            >
              &times;
            </button>
          </div>
        ))}
        <button
          onClick={() => {
            const updatedFields = [...formValues.formFields];
            updatedFields[index].options.push('');
            setFormValues({ ...formValues, formFields: updatedFields });
          }}
          className="text-blue-500 hover:text-blue-700"
        >
          + Add Option
        </button>
        {errors[`field_${index}_options`] && <div className="text-red-500 text-sm">{errors[`field_${index}_options`]}</div>}
      </div>
    ) : (
      <div className="text-gray-500">N/A</div>
    )}
    <div className="flex space-x-2">
  <button
    onClick={() => removeField(index)}
    className="px-3 py-1 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none"
  >
    Remove
  </button>
</div>
  </div>
  
))}
</>
) : 'No Data'}


          
       

      <div className="flex justify-between mt-6">
        <button
          onClick={addField}
          className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 focus:outline-none"
        >
          Add Field
        </button>
        <button
          onClick={handleSubmit}
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none"
        >
           {loading ? 'Submitting...' : selectedVerificationType ? 'Update' : 'Submit'}
        </button>
      </div>
      {apiResponse && (
                    <motion.div
                        className={`mt-4 flex items-center ${apiResponse.error ? 'text-red-500' : 'text-green-500'}`}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        {apiResponse.error ? (
                            <>
                                <FaExclamationCircle className="mr-2" />
                                {apiResponse.error}
                            </>
                        ) : (
                            <>
                                <FaCheckCircle className="mr-2" />
                                {apiResponse.success}
                            </>
                        )}
                    </motion.div>
                )}
    </div>
  );
};


const VerificationTypeListTable = ({ onSelectVerificationType, switchToFormTab }) => {
  const tableHeaders = ["id", "Code", "Component", "CreatedAt"];

  const [list, setList] = useState([]);  // Store Clients

  const [loading, setLoading] = useState(false);

  // Fetch Clients when the component loads
  useEffect(() => {
      const getData = async (cleintId) => {
          try {
              const data =  await fetchVerficationTypeData(localStorage.getItem('clientID'));  // Fetch countries from service
              const options = data.map((verificationType) => ({
                  id: verificationType.verificationTypeId,
                  verificationType: verificationType.verificationType,
                  verificationCode: verificationType.verificationCode,
                  clientId: verificationType.clientId,
                  clientName: verificationType.clientName,
                  createdAt: verificationType.createdAt
              }));
              setList(options);  // Set the countries as options for the select dropdown

          } catch (error) {
              console.error("Error fetching countries:", error);
          } finally {
              // setLoadingCountries(false);  // Stop loading spinner
          }
      };

      getData();
  }, []);


  // Mapping of headers to data keys
  const headerMapping = {
      "id": "id",
      "Code": "verificationCode", // Maps to the data key 'clientName'
      "Component": "verificationType", // Assuming you have 'email' key in your data. If not, replace accordingly
      "CreatedAt": "createdAt" // Maps to the data key 'createdAt'
  };


  const handleEdit = async (rowObject) => {
      try {
          setLoading(true); // Show loading spinner

          // Fetch client data based on the row object (e.g., client ID)
          const verificationType = await fetchVerificationTypeDataById(rowObject.id);
          var verificationTypeData = ({
              verificationTypeId: verificationType.verificationTypeId,
              verificationType: verificationType.verificationType,
              formFields :  verificationType.formFields,
              clientId: verificationType.clientId,
              clientName: verificationType.clientName,
              createdAt: verificationType.createdAt

          });
          // Populate the form with the fetched client data
          onSelectVerificationType(verificationTypeData);

          // Switch to the form tab
          switchToFormTab();

      } catch (error) {
          console.error('Error fetching client data:', error);
      } finally {
          setLoading(false); // Hide loading spinner
      }
  };


  return (
      <div className="container mx-auto p-6 bg-white rounded-lg border">
          <AdvancedDataTableComponent
              headers={tableHeaders}
              data={list}
              headerMapping={headerMapping}
              onEdit={handleEdit}
              showActions={false}
          />
      </div>
  );

};


const TestPage = () => {

  const [selectedVerificationType, setselectedVerificationType] = useState(null); // Track selected client for editing
  const [activeTab, setActiveTab] = useState(0); // Track active tab

  const handleEdit = (verificationType) => {
      setselectedVerificationType(verificationType);
      setActiveTab(0);
  };
  const handleVerificationTypeUpdated = () => {
      setselectedVerificationType(null);
  };
  return (<TabbedFormComponent
      formContent={(switchToFormTab) => (
          // <VerificationTypeForm
          //     selectedVerificationType={selectedVerificationType}
          //     onVerificationTypeUpdated={handleVerificationTypeUpdated}
          //     switchToFormTab={switchToFormTab}
          // />
          <p></p>
      )}
      dataTableComponent={(switchToFormTab) => (
          <VerificationTypeListTable
              onSelectVerificationType={setselectedVerificationType}
              switchToFormTab={switchToFormTab}
          />
      )}
  />)
};

export default TestPage;
